import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin } from "../redux/actions";

/**
 * @author
 * @function Login
 **/

export const Login = (props) => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = { email, password };

    // Dispatch login action
    dispatch(adminLogin(data));
  };

  if (auth?.authenticate) {
    window.location.href = "/";
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-sm p-8">
        {/* Brand */}
        <h1 className="text-2xl font-semibold text-center text-gray-900">
          Ali Store BD
        </h1>
        <p className="text-sm text-center text-gray-500 mb-6">
          Admin Dashboard
        </p>

        {/* Form */}
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Email</label>
            <input
              type="email"
              placeholder="admin@alistore.com.bd"
              className="w-full px-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-gray-900"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Password</label>
            <input
              type="password"
              placeholder="••••••••"
              className="w-full px-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-gray-900"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="w-full bg-gray-900 text-white py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition"
          >
            Sign In
          </button>
        </form>

        {/* Footer */}
        <p className="text-xs text-center text-gray-400 mt-6">
          © {new Date().getFullYear()} Ali Store BD All rights reserved.
        </p>
      </div>
    </div>
  );
};
